<template>
  <div class="picky-cat-features__carousel">
    <div class="picky-cat-features__title">
      {{ title }}
    </div>
    <div class="picky-cat-features__carousel-inner">
      <div v-if="paginationOutsideOpts" ref="paginaton" :class="`swiper-pagination swiper-pagination-outside-${uuid}`"></div>
      <swiper
          :modules="modules"
          :effect="'coverflow'"
          :centeredSlides="true"
          :slidesPerView="'auto'"
          :navigation="navMain"
          :spaceBetween="slideSpaceBetween"
          :coverflowEffect="{
          rotate: 0,
          depth: 0,
          modifier: 1,
          stretch: 46,
          slideShadows: false,
        }"
          @swiper="setSwiperRef"
          @slideChange="onSlideChange"
          :loop="true"
          :pagination="windowWidth < 768"
      >
        <div class="picky-cat-features__carousel-nav">
          <div class="picky-cat-features__carousel-prev" @click="swiperPrevSlide">
            <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 9L1 9" stroke="#73317A" stroke-width="2" stroke-linecap="round"/>
              <path d="M9 17L1 9L9 1" stroke="#73317A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="picky-cat-features__carousel-next" @click="swiperNextSlide">
            <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 9L21 9" stroke="#73317A" stroke-width="2" stroke-linecap="round"/>
              <path d="M13 1L21 9L13 17" stroke="#73317A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        <swiper-slide
            v-for="(feature, index) in features"
            :key="index"
        >
          <div class="picky-cat-features__item" :class="{'_carrot': index === 4}">
            <div class="picky-cat-features__item-image">
              <img :src="feature.imageUrl">
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="picky-cat-features__item-info">
        <div class="picky-cat-features__item-title" v-html="activeSlide.title"/>
        <div class="picky-cat-features__item-text" v-html="activeSlide.text" />
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, computed, getCurrentInstance, onMounted} from 'vue';
import { EffectCoverflow, Pagination } from 'swiper';


const modules = [EffectCoverflow, Pagination];

const instance = getCurrentInstance();
const uuid = ref(instance.uid)

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  features: {
    type: Array,
    default: []
  }
});

const navMain = {
  nextEl: '.picky-cat-features__carousel-next',
  prevEl: '.picky-cat-features__carousel-prev',
};

let windowWidth = ref(window.innerWidth);

const paginationOutsideOpts = windowWidth.value < 768 ? {
  el: `.swiper-pagination-outside-${uuid.value}`,
  clickable: true
} : null;

let swiperRef = ref(null);

const setSwiperRef = (swiper) => {
  swiperRef.value = swiper;
};

onMounted(() => {
  resizeHandler;
  window.addEventListener('resize', resizeHandler);
})

const swiperPrevSlide = () => {
  swiperRef.value.slidePrev()
}

const swiperNextSlide = () => {
  swiperRef.value.slideNext()
}

let activeSlide = ref(props.features[0]);

const onSlideChange = () => {
  activeSlide.value = props.features[swiperRef.value?.realIndex];
}

const resizeHandler = () => {
  windowWidth.value = window.innerWidth;
}

const slideSpaceBetween =  computed(() => {
  return windowWidth.value < 1024 ? 70 : 139;
})
</script>

<style scoped>

</style>